import { render, staticRenderFns } from "./UtilisateurMenu.vue?vue&type=template&id=3935b84f&scoped=true&"
import script from "./UtilisateurMenu.vue?vue&type=script&lang=js&"
export * from "./UtilisateurMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935b84f",
  null
  
)

export default component.exports